import {post} from '@/utils/request'

export function getLogin(data) {
  return post('admin/login/login',data)
}